__turbopack_context__.v({
  "bottomRow": "ClubProfileStats-module-scss-module__VRUnKq__bottomRow",
  "challengesCard": "ClubProfileStats-module-scss-module__VRUnKq__challengesCard",
  "earnedApCard": "ClubProfileStats-module-scss-module__VRUnKq__earnedApCard",
  "fansCard": "ClubProfileStats-module-scss-module__VRUnKq__fansCard",
  "fansViewsCard": "ClubProfileStats-module-scss-module__VRUnKq__fansViewsCard",
  "leftBlock": "ClubProfileStats-module-scss-module__VRUnKq__leftBlock",
  "leftLabel": "ClubProfileStats-module-scss-module__VRUnKq__leftLabel",
  "leftValue": "ClubProfileStats-module-scss-module__VRUnKq__leftValue",
  "middleColumn": "ClubProfileStats-module-scss-module__VRUnKq__middleColumn",
  "rankComingSoon": "ClubProfileStats-module-scss-module__VRUnKq__rankComingSoon",
  "rankFire": "ClubProfileStats-module-scss-module__VRUnKq__rankFire",
  "rankValueWrap": "ClubProfileStats-module-scss-module__VRUnKq__rankValueWrap",
  "rightColumn": "ClubProfileStats-module-scss-module__VRUnKq__rightColumn",
  "stats": "ClubProfileStats-module-scss-module__VRUnKq__stats",
  "wrapper": "ClubProfileStats-module-scss-module__VRUnKq__wrapper",
});
